import { render, staticRenderFns } from "./LiquorCategory.vue?vue&type=template&id=7d149f97&scoped=true&"
import script from "./LiquorCategory.vue?vue&type=script&lang=js&"
export * from "./LiquorCategory.vue?vue&type=script&lang=js&"
import style0 from "./LiquorCategory.vue?vue&type=style&index=0&id=7d149f97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d149f97",
  null
  
)

export default component.exports